import { render, staticRenderFns } from "./PayrollGroups.vue?vue&type=template&id=8a95edf0&scoped=true&"
import script from "./PayrollGroups.vue?vue&type=script&lang=js&"
export * from "./PayrollGroups.vue?vue&type=script&lang=js&"
import style0 from "./PayrollGroups.vue?vue&type=style&index=0&id=8a95edf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a95edf0",
  null
  
)

export default component.exports